import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  fonts: {
    body: "Vazir, sans-serif",
    heading: "Vazir, sans-serif",
  },
});
